// extracted by mini-css-extract-plugin
export var closed = "_bi-1";
export var resizer = "_bi-0";